import type { TeamUser, TeamWithUsers } from 'factories/teams';
import type { XhrStatus } from 'redux/reusable/xhrStatus';
import { createXhrStatusModule } from 'redux/reusable/xhrStatus';
import type { TEAM_SCHEMA_KEY } from 'schema/teams';
import type { Team } from 'types/team';
import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('timely/teams');

export const { wrapFetching, wrapSaving, withXhrStatusReducer } = createXhrStatusModule('teams');

export const fetchedTeam = actionCreator<TeamsSchemaPayload>('FETCHED_TEAM');
export const addTeam = actionCreator<TeamSchemaPayload>('ADD_TEAM');
export const deleteTeam = actionCreator<number>('DELETE_TEAM');
export const editTeam = actionCreator<TeamSchemaPayload>('EDIT_TEAM');
export const updateTeamDraft = actionCreator<Partial<TeamWithUsers> | null>('UPDATE_TEAM_DRAFT');
export const addUserToTeamDraft = actionCreator<TeamUser>('ADD_USER_TO_TEAM_DRAFT');
export const removeUserFromTeamDraft = actionCreator<TeamUser>('REMOVE_USER_FROM_TEAM_DRAFT');
export const addTeamLeadToTeamDraft = actionCreator<TeamUser>('ADD_TEAM_LEAD_TO_TEAM_DRAFT');
export const removeTeamLeadFromTeamDraft = actionCreator<TeamUser>(
  'REMOVE_TEAM_LEAD_FROM_TEAM_DRAFT'
);
export const toggleTeamsModal = actionCreator<boolean>('TOGGLE_MODAL');

export interface State {
  draft: Team | null;
  entities: {
    [TEAM_SCHEMA_KEY]: {
      [id: number]: Team;
    };
  };
  result: Array<number>;
  showTeamsManagementModal: boolean;
  xhrStatus: XhrStatus;
}

export interface TeamsSchemaPayload {
  result: Array<number>;
  entities: {
    [TEAM_SCHEMA_KEY]: {
      [teamId: number]: Team;
    };
  };
}
export interface TeamSchemaPayload {
  result: number;
  entities: {
    [TEAM_SCHEMA_KEY]: {
      [teamId: number]: Team;
    };
  };
}
